import React from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
const CurrencyAdornment = () => /*#__PURE__*/React.createElement(InputAdornment, {
  position: "start"
}, "\u20AC");
export default CurrencyAdornment;